var _style, _path, _line, _line2, _line3, _line4, _polyline, _line5, _line6, _line7, _line8, _line9, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCampaignItem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 595.28 841.89",
    style: {
      enableBackground: "new 0 0 595.28 841.89"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;stroke:#000000;stroke-width:15;stroke-miterlimit:10;}\n\t.st1{fill:none;stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st2{fill:none;stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M202.27,561.21l-48.79,41.41c-0.65,0.54-1.64,0.08-1.64-0.77V367.46c0-11.05,8.95-20,20-20h252.64 c11.05,0,20,8.95,20,20v173.52c0,11.05-8.95,20-20,20H202.91C202.67,560.98,202.45,561.06,202.27,561.21z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 298.16,
    y1: 603.65,
    x2: 298.16,
    y2: 641.62
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 355.67,
    y1: 600.85,
    x2: 381.76,
    y2: 627.06
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 240.32,
    y1: 600.85,
    x2: 214.22,
    y2: 627.06
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 298.16,
    y1: 305.18,
    x2: 298.16,
    y2: 267.22
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "235.84,487.96 258.18,420.95 280.86,487.96 "
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 355.67,
    y1: 307.98,
    x2: 381.76,
    y2: 281.78
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 240.32,
    y1: 307.98,
    x2: 214.22,
    y2: 281.78
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 443.31,
    y1: 530.57,
    x2: 386.02,
    y2: 530.57
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 355.92,
    y1: 530.57,
    x2: 355.67,
    y2: 530.57
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 242.39,
    y1: 468.3,
    x2: 274.21,
    y2: 468.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M328.74,421.34c-5.88,0-13.44,0-13.44,0v66.62c0,0,8.06,0,13.44,0s31.75,0,31.75-33.04 S334.61,421.34,328.74,421.34z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaignItem);
export default __webpack_public_path__ + "static/media/campaign_item.223f27a1d91cabe7b5c2468c2afb5e1b.svg";
export { ForwardRef as ReactComponent };